module.exports = __webpack_public_path__ + "img/hexagon-half.19ff5c6b.svg";